define('views/components/customer_settings/profile_settings',['require','views/base/item_page_view','text!templates/components/customer_settings/profile_settings.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');

    var temp = require("text!templates/components/customer_settings/profile_settings.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),

        ui: function() {
            return {    
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',
            
                gdprLink: '#gdpr-link',
                kvkkLink: '#kvkk-link',
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',
            
            'click @ui.gdprLink': 'gdprLinklClicked',
            'click @ui.kvkkLink': 'kvkkLinkClicked'
        },

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'first_name': "required",
                    'last_name': "required",
                    'sector': "required",
                    'phone_country': "required",
                    'phone_value': "required"
                },
                messages: {
                    'first_name': App.polyglot.t('manager_first_name_required'),
                    'last_name': App.polyglot.t('manager_last_name_required'),
                    'phone_country': App.polyglot.t('phone_country_required'),
                    'phone_value': App.polyglot.t('phone_value_required')
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },


        gdprLinklClicked: function (event) {
            window.open('https://gdpr.eu/tag/gdpr/', '_blank');
        },

        kvkkLinkClicked: function () {
            window.open('https://www.mevzuat.gov.tr/mevzuat?MevzuatNo=6698&MevzuatTur=1&MevzuatTertip=5', '_blank');
        }
    });
});
